import { Fab, Tooltip } from '@mui/material'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import { useState } from 'react'
import JurnalModal from './JurnalModal'

type Props = {
    id?: number | null
    tabel?: string
}

export default function FloatingJurnalButton({ id, tabel }: Props) {
    const [open, setOpen] = useState(false)

    if (!id || !tabel) return null

    return (
        <>
            <Tooltip title="Lihat Jurnal">
                <Fab
                    variant="extended"
                    color="primary"
                    onClick={() => setOpen(true)}
                    sx={{
                        position: 'fixed',
                        bottom: 90, // 🔥 naik dari 24 → 80
                        right: 24,
                        zIndex: 9999
                    }}
                >
                    <ReceiptLongIcon sx={{ mr: 1 }} />
                    Lihat Jurnal
                </Fab>
            </Tooltip>


            <JurnalModal
                open={open}
                onClose={() => setOpen(false)}
                id={id}
                tabel={tabel}
            />
        </>
    )
}
